import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo_kz.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-right" }
const _hoisted_3 = { class: "username" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header-left" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Logo",
        class: "logo",
        style: {"height":"56px"}
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.username), 1),
      _createVNode(_component_el_button, {
        type: "text",
        class: "logout-button",
        onClick: _ctx.handleLogout
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'sign-out-alt'] })
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}